import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "media-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "media-list" }
const _hoisted_6 = ["onClick"]

import { PropType, reactive, ref } from 'vue';
import { ModalToolbar } from 'md-editor-v3';
import type { Insert } from 'md-editor-v3';
import { Media, videoRules } from '@/models/media.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaToolbar',
  props: {
  /**
   * `insert` will be automatically injected into the component by the editor
   */
  insert: {
    type: Function as PropType<Insert>,
    default: () => {
      //
    },
  },
  media: { type: Array as PropType<Media[]>, default: () => [] },
},
  setup(__props) {

const data = reactive({
  modalVisible: false,
  modalFullscreen: false,
});

const props = __props;

const imageUrl = ref<string>('');
const image = ref<Media | null>(null);
const size = ref<string>('small');
const videoUrl = ref<string>('');

const sizes = ['small', 'medium', 'large'];

const getSource = (m: Media) => {
  return m.file ? `/file/${m.file.uuid}/${size.value}.webp` : '';
};

const selectImage = (m: Media) => {
  image.value = image.value?.id === m.id ? null : m;
};

const selectSize = (s: string) => {
  size.value = s;
};

const handler = (type: string, url: string, title: string) => {
  // props.insert((selectedText) => {
  props.insert(() => {
    /**
     * targetValue    Content to be inserted
     * select         Automatically select content, default: true
     * deviationStart Start position of the selected content, default: 0
     * deviationEnd   End position of the selected content, default: 0
     */
    return {
      targetValue: `![${type}](${url}${title ? ` ${title}` : ''})`,
      select: true,
      deviationStart: 0,
      deviationEnd: 0,
    };
  });

  data.modalVisible = false;
};

const chooseImage = () => {
  if (imageUrl.value !== '') {
    handler('internet-image', imageUrl.value, '');
  } else if (image.value) {
    handler('shift-image', getSource(image.value), '');
  }
};
const tab = ref<string>('local-image');
const rotation = ref<string>('internet-video');

const chooseVideo = () => {
  if (videoUrl.value !== '') {
    handler(rotation.value, videoUrl.value, '');
    // } else if (image.value) {
    //   handler('shift-video', getSource(image.value), '');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_unref(ModalToolbar), {
    visible: data.modalVisible,
    isFullscreen: data.modalFullscreen,
    title: "media",
    modalTitle: "Insert Media",
    width: "600px",
    height: "500px",
    onOnClick: _cache[7] || (_cache[7] = ($event: any) => (data.modalVisible = true)),
    onOnClose: _cache[8] || (_cache[8] = ($event: any) => (data.modalVisible = false)),
    onOnAdjust: _cache[9] || (_cache[9] = ($event: any) => (data.modalFullscreen = !data.modalFullscreen))
  }, {
    trigger: _withCtx(() => _cache[24] || (_cache[24] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "lucide lucide-image-icon md-editor-icon"
      }, [
        _createElementVNode("rect", {
          width: "18",
          height: "18",
          x: "3",
          y: "3",
          rx: "2",
          ry: "2"
        }),
        _createElementVNode("circle", {
          cx: "9",
          cy: "9",
          r: "2"
        }),
        _createElementVNode("path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" })
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        "fixed-tabs": "",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "image" }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Image")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "video" }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Video")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, { value: "image" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createElementVNode("h3", null, "Insert an image into the text", -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("p", null, "Provide a url to an image", -1)),
                  _createVNode(_component_v_text_field, {
                    label: "URL",
                    modelValue: imageUrl.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((imageUrl).value = $event)),
                    placeholder: "https://"
                  }, null, 8, ["modelValue"]),
                  _cache[18] || (_cache[18] = _createElementVNode("p", null, "Or select an image from the attached media", -1)),
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.media, (m) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: m.id,
                        class: _normalizeClass(["media-item", { 'media-item-selected': image.value?.id === m.id }]),
                        onClick: ($event: any) => (selectImage(m))
                      }, [
                        _createElementVNode("img", {
                          src: getSource(m)
                        }, null, 8, _hoisted_3)
                      ], 10, _hoisted_2))
                    }), 128))
                  ]),
                  (image.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _cache[12] || (_cache[12] = _createElementVNode("p", null, "And select the size of the media to be used.", -1)),
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sizes, (s) => {
                            return _createElementVNode("div", {
                              key: s,
                              class: _normalizeClass(["media-item", { 'media-item-selected': size.value === s }]),
                              onClick: ($event: any) => (selectSize(s))
                            }, _toDisplayString(s.substring(0, 1).toUpperCase()) + _toDisplayString(s.substring(1)), 11, _hoisted_6)
                          }), 64))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (imageUrl.value && image.value)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "info"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("The URL will be used, even though you have an image selected.")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { col: "2" }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            type: "reset",
                            block: "",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (data.modalVisible = false))
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("Cancel")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            block: "",
                            type: "button",
                            onClick: chooseImage
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("Save")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { col: "2" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, { value: "video" }, {
            default: _withCtx(() => [
              _cache[23] || (_cache[23] = _createElementVNode("h2", null, "Use a video", -1)),
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Insert video into the text", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("p", null, "Provide a url to a video", -1)),
                  _createVNode(_component_v_text_field, {
                    label: "URL",
                    modelValue: videoUrl.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((videoUrl).value = $event)),
                    rules: _unref(videoRules),
                    placeholder: "https://"
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_v_radio_group, {
                    modelValue: rotation.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rotation).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "Landscape",
                        value: "internet-video"
                      }),
                      _createVNode(_component_v_radio, {
                        label: "Portrait",
                        value: "internet-portrait-video"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { col: "2" }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            type: "reset",
                            block: "",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (data.modalVisible = false))
                          }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode("Cancel")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "mt-2",
                            block: "",
                            type: "button",
                            onClick: chooseVideo
                          }, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode("Save")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { col: "2" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["visible", "isFullscreen"]))
}
}

})